import { AuthClientConfig } from '@auth0/auth0-angular';
import { Banner, BANNER_CONFIG } from '../data/banner.data';
import { DomianProviderService } from './domain-provider.service';
export interface AppConfig {
  domain: string;
  clientId: string;
}

/**
 * Extract banner from URL path
 * Supports paths like: /banner/shoprite, /shoprite, or query param ?banner=shoprite
 */
export function getBannerFromUrl(): Banner {
  const path = window.location.pathname;
  const segments = path.split('/').filter((s) => s);
  for (const segment of segments) {
    if (Object.values(Banner).includes(segment as Banner)) {
      return segment as Banner;
    }
  }

  return Banner.SHOPRITE;
}

export function authConfigProvider(
  bannerService: DomianProviderService,
  config: AuthClientConfig
) {
  return () => {
    // Try to get banner from URL first, then fall back to domain detection
    const currentBanner =
      getBannerFromUrl() ||
      (bannerService.getBanner() as Banner) ||
      Banner.SHOPRITE;

    const banner = BANNER_CONFIG[currentBanner];

    config.set({
      domain: process.env['AUTH0_DOMAIN'] || '',
      clientId: banner.authClientId || '',
      cacheLocation: window.top === window.self ? 'localstorage' : 'memory',
      useRefreshTokens: true,
      useRefreshTokensFallback: true,
      authorizationParams: {
        redirect_uri: `${window.location.origin}/callback`,
        scope: 'openid profile email offline_access',
        audience: process.env['AUTH0_AUDIENCE'] || undefined,
      },
    });
    return config;
  };
}
